import React from 'react';

import style from './index.module.css';
import Spinner from '../../static/images/loading_spinner.svg';

// TODO: Use a union type for to vs. onClick.
type Props = {
    children: React.ReactNode;
    type?: 'secondary' | 'tertiary' | 'gold';
    large?: boolean;
    disabled?: boolean;
    loading?: boolean;
    onClick?: (event?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => void;
};

export const Button = ({ children, onClick, disabled, loading, large, type }: Props): React.ReactElement => {
    const buttonClass = (type?: 'secondary' | 'tertiary' | 'gold') => (type ? style[type] : '');
    const className = `${style.button} ${type ? buttonClass(type) : ''} ${loading ? style.loading : ''} ${
        large ? style.large : ''
    }
  `;
    return (
        <button onClick={onClick} className={className} type="button" disabled={disabled}>
            {loading ? (
                <div className={style.spinner}>
                    <Spinner />
                </div>
            ) : (
                children
            )}
        </button>
    );
};
